import Script from 'next/script';

import { isProduction } from 'utils/helpers';

const AtreemoTrackingScript = () => {
  if (!isProduction()) return null;
  return (
    <>
      <Script
        strategy="beforeInteractive"
        src="https://tracking.atreemo.com/Scripts/TrackingInit.js"
      />
      <Script
        strategy="beforeInteractive"
        src="https://tracking.atreemo.com/Scripts/Tracking.js"
      />
      <Script
        id="atreemo-tracking-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            AtreemoTrackingLbr.init(["Clays, https://tools.updates.clays.bar/WebEcasts"]);
        `,
        }}
      />
    </>
  );
};

export default AtreemoTrackingScript;
